import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Route, Switch } from 'react-router-dom';
import { LoadingOverlay } from '@airtm/airtm-ui';
import useCleanAndValidateQueryParams from 'utils/useCleanAndValidateQueryParams';
import ApolloNetworkStatus from './ApolloNetworkStatus';
import Notifications from './Notifications/Notifications';
import Layout from './Layout/Layout';
import useSession from './useSession';
import CookieBanner from './CookieBanner';

const Login = lazy(() => import('screens/Login/Login'));
const SignUp = lazy(() => import('screens/SignUp/SignUp'));
const ForgotPassword = lazy(() => import('screens/ForgotPassword/ForgotPassword'));
const RecoverPassword = lazy(() => import('screens/RecoverPassword/RecoverPassword'));
const CreateMemberPassword = lazy(
  () => import('screens/CreateMemberPassword/CreateMemberPassword'),
);

const Routes = function () {
  useSession();
  useCleanAndValidateQueryParams();

  return (
    <>
      <ApolloNetworkStatus />
      <CookieBanner />
      <Notifications />
      <Suspense fallback={<LoadingOverlay />}>
        <Helmet defaultTitle="Airtm - Get Paid Better" titleTemplate="Airtm - %s" />
        <Switch>
          {/* Public routes */}
          <Route path="/login" component={Login} />
          <Route path="/sign-up" component={SignUp} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/recover-password" exact component={RecoverPassword} />
          <Route path="/create-member-password" exact component={CreateMemberPassword} />
          {/* Private routes */}
          <Route path="/" component={Layout} />
          <Redirect to="/login" />
        </Switch>
      </Suspense>
    </>
  );
};

export default Routes;
